import {
  ICustomerWallet,
  ICustomerWalletCategory
} from '@hub-workspace/apps/logged-home/src/app/shared/modules/customer-wallet/interfaces/customer-wallet.interface';
import { CustomerWalletAction } from './customer-wallet.action';

export interface CustomerWalletState {
  wallet: ICustomerWallet;
  pending: boolean;
  isLoaded: boolean;
  walletError: string;
}

export const initialState: CustomerWalletState = {
  wallet: null,
  pending: false,
  isLoaded: false,
  walletError: null
};

export function CustomerWalletReducer(
  state: CustomerWalletState = initialState,
  action?: CustomerWalletAction
): CustomerWalletState {
  switch (action.type) {
    case CustomerWalletAction.getCustomerWallet: {
      return {
        ...state,
        ...{ pending: true }
      };
    }

    case CustomerWalletAction.getCustomerWalletSuccess: {
      const wallet = action.payload as ICustomerWallet;

      if (!wallet) {
        return {
          ...state,
          ...{
            pending: false,
            isLoaded: true,
            wallet: wallet
          }
        };
      }

      return {
        ...state,
        ...{
          pending: false,
          isLoaded: true,
          wallet: {
            ...wallet,
            updatedAt: new Date(wallet.updatedAt)
              .toISOString()
              .replace('.000Z', ''),
            categories: wallet.categories.map(categry => ({
              ...categry,
              slug: categry.name
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/ /g, '-')
            }))
          }
        }
      };
    }

    case CustomerWalletAction.getCustomerWalletError:
      return {
        ...state,
        ...{
          pending: false,
          isLoaded: true,
          customerWalletError: action.payload
        }
      };

    default:
      return state;
  }
}
